import i18n from "./i18n.ts";
import { MobileTooltip } from "../components/MobileTooltip.tsx";

type PositionDisplay = "full" | "short";

export const translatePosition = (
	pos: string | undefined,
	display: PositionDisplay = "short",
): string => {
	if (!pos) {
		return "";
	}

	const translated = i18n.t(`positionName.${pos}.${display}`, {
		ns: "ui",
		defaultValue: pos,
	});

	return typeof translated === "string" && translated.length > 0
		? translated
		: pos;
};

export const PositionText = ({
	pos,
	display = "short",
}: {
	pos: string | undefined;
	display?: PositionDisplay;
}) => {
	if (!pos) {
		return null;
	}

	const text = translatePosition(pos, display);
	const title = translatePosition(pos, "full");

	return (
		<MobileTooltip title={text === title ? undefined : title}>
			<span>{text}</span>
		</MobileTooltip>
	);
};

export const wrappedPosition = (pos: string | undefined) => {
	if (!pos) {
		return null;
	}

	const short = translatePosition(pos, "short");
	const full = translatePosition(pos, "full");

	return {
		value: (
			<MobileTooltip title={short === full ? undefined : full}>
				<span>{short}</span>
			</MobileTooltip>
		),
		searchValue: `${pos} ${short} ${full}`,
		sortValue: pos,
	};
};
